import { routes } from "../apiroutes";
import HttpService from "../httpServices";
import useFetchItem from "../useFetchItem";
import useMutateItem from "../useMutateItem";
import { getAccessToken, parseData } from "../../utils";
import { ErrorHandler } from "../errorHandler";
import { showErrorAlert, showSuccessAlert } from "../../utils/alert";

const httpService = new HttpService();



export const useFetchLocations = ({ enabled = true }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
        queryKey: ["FetchLocations"],
        queryFn: () => httpService.getData(routes.getLocations(),),
        enabled,
        retry: 2
    });

    return {
        getLocationsIsFetching: isFetching,
        getLocationsIsFetched: isFetched,
        getLocationsIsLoading: isLoading,
        getLocationsError: ErrorHandler(error),
        getLocationsData: data?.data || [],
        refetchGetLocations: refetch
    };
};

export const useAddLocation = (handleSuccess) => {
    const { data, error, isPending, mutate } = useMutateItem({
      mutationFn: (payload) =>
        httpService.postData(payload, routes.createLocations()),
      onSuccess: (res) => {
        const resData = res?.data || {};
        showSuccessAlert(resData?.message);
        handleSuccess(resData);
      },
      onError: (err) => {
        // console.log(err); err 401
        const error = ErrorHandler(err);
        showErrorAlert(error);
      },
    });
  
    return {
      addLocationData: data,
      addLocationError: ErrorHandler(error),
      addLocationIsLoading: isPending,
      addLocationPayload: (requestPayload) => mutate(requestPayload),
    };
  };
  

export const useEditLocation = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.editLocations(payload?.id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    editLocationData: data,
    editLocationError: ErrorHandler(error),
    editLocationIsLoading: isPending,
    editLocationPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useDeleteLocation = (handleSuccess) => {
    const { data, error, isPending, mutate } = useMutateItem({
      mutationFn: (id) =>
        httpService.deleteData(routes.deleteLocations(id)),
      onSuccess: (res) => {
        const resData = res?.data || {};
        showSuccessAlert(resData?.message);
        handleSuccess(resData);
      },
      onError: (err) => {
        const error = ErrorHandler(err);
        showErrorAlert(error);
      },
    });
  
    return {
      deleteLocationData: data,
      deleteLocationError: ErrorHandler(error),
      deleteLocationIsLoading: isPending,
      deleteLocationPayload: (requestPayload) => mutate(requestPayload),
    };
  };
  


export const useFetchDepartments = ({ enabled = true }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
        queryKey: ["FetchDepartments"],
        queryFn: () => httpService.getData(routes.getDepartments(),),
        enabled,
        retry: 2
    });

    return {
        getDepartmentIsFetching: isFetching,
        getDepartmentIsFetched: isFetched,
        getDepartmentIsLoading: isLoading,
        getDepartmentError: ErrorHandler(error),
        getDepartmentData: data?.data || [],
        refetchGetDepartment: refetch
    };
};

export const useAddDepartment = (handleSuccess) => {
    const { data, error, isPending, mutate } = useMutateItem({
      mutationFn: (payload) =>
        httpService.postData(payload, routes.createDepartments()),
      onSuccess: (res) => {
        const resData = res?.data || {};
        showSuccessAlert(resData?.message);
        handleSuccess(resData);
      },
      onError: (err) => {
        const error = ErrorHandler(err);
        showErrorAlert(error);
      },
    });
  
    return {
      addDepartmentData: data,
      addDepartmentError: ErrorHandler(error),
      addDepartmentIsLoading: isPending,
      addDepartmentPayload: (requestPayload) => mutate(requestPayload),
    };
  };

  export const useEditDepartment = (handleSuccess) => {
    const { data, error, isPending, mutate } = useMutateItem({
      mutationFn: (payload) =>
        httpService.putData(payload, routes.editDepartment(payload?.id)),
      onSuccess: (res) => {
        const resData = res?.data || {};
        showSuccessAlert(resData?.message);
        handleSuccess(resData);
      },
      onError: (err) => {
        const error = ErrorHandler(err);
        showErrorAlert(error);
      },
    });
  
    return {
      editDepartmentData: data,
      editDepartmentError: ErrorHandler(error),
      editDepartmentIsLoading: isPending,
      editDepartmentPayload: (requestPayload) => mutate(requestPayload),
    };
  };


  export const useDeleteDepartment = (handleSuccess) => {
    const { data, error, isPending, mutate } = useMutateItem({
      mutationFn: (id) =>
        httpService.deleteData(routes.deleteDepartment(id)),
      onSuccess: (res) => {
        const resData = res?.data || {};
        showSuccessAlert(resData?.message);
        handleSuccess(resData);
      },
      onError: (err) => {
        const error = ErrorHandler(err);
        showErrorAlert(error);
      },
    });
  
    return {
      deleteDepartmentData: data,
      deleteDepartmentError: ErrorHandler(error),
      deleteDepartmentIsLoading: isPending,
      deleteDepartmentPayload: (requestPayload) => mutate(requestPayload),
    };
  };

  export const useFetchReportTo = ({ enabled = true }) => {
    const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
        queryKey: ["FetchReportTo"],
        queryFn: () => httpService.getData(routes.getReportTo(),),
        enabled,
        retry: 2
    });

    return {
        getReportToIsFetching: isFetching,
        getReportToIsFetched: isFetched,
        getReportToIsLoading: isLoading,
        getReportToError: ErrorHandler(error),
        getReportToData: data?.data || [],
        refetchGetReportTo: refetch
    };
};


export const useAddReportTo = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.postData(payload, routes.createReportTo()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    addReportToData: data,
    addReportToError: ErrorHandler(error),
    addReportToIsLoading: isPending,
    addReportToPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useEditReportTo = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.editReportTo(payload?.id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    editReportToData: data,
    editReportToError: ErrorHandler(error),
    editReportToIsLoading: isPending,
    editReportToPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useDeleteReportTo = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (id) =>
      httpService.deleteData(routes.deleteReportTo(id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    deleteReportToData: data,
    deleteReportToError: ErrorHandler(error),
    deleteReportToIsLoading: isPending,
    deleteReportToPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useFetchShift = ({ enabled = true }) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
      queryKey: ["FetchShift"],
      queryFn: () => httpService.getData(routes.getShift(),),
      enabled,
      retry: 2
  });

  return {
      getShiftIsFetching: isFetching,
      getShiftIsFetched: isFetched,
      getShiftIsLoading: isLoading,
      getShiftError: ErrorHandler(error),
      getShiftData: data?.data || [],
      refetchGetShift: refetch
  };
};

export const useAddShift = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.postData(payload, routes.createShift()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    addShiftData: data,
    addShiftError: ErrorHandler(error),
    addShiftIsLoading: isPending,
    addShiftPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useEditShift = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.editShift(payload?.id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    editShiftData: data,
    editShiftError: ErrorHandler(error),
    editShiftIsLoading: isPending,
    editShiftPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useDeleteShift = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (id) =>
      httpService.deleteData(routes.deleteShift(id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message);
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    deleteShiftData: data,
    deleteShiftError: ErrorHandler(error),
    deleteShiftIsLoading: isPending,
    deleteShiftPayload: (requestPayload) => mutate(requestPayload),
  };
};

// Holidays Management Hooks
export const useFetchHolidays = ({ enabled = true, filters = {} } = {}) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
    queryKey: ["FetchHolidays", filters],
    queryFn: () => httpService.getData(routes.getHolidays(filters)),
    enabled,
    retry: 2
  });

  return {
    getHolidaysIsFetching: isFetching,
    getHolidaysIsFetched: isFetched,
    getHolidaysIsLoading: isLoading,
    getHolidaysError: ErrorHandler(error),
    getHolidaysData: data?.data || [],
    refetchGetHolidays: refetch
  };
};

export const useAddHoliday = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.postData(payload, routes.createHoliday()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Holiday created successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    addHolidayData: data,
    addHolidayError: ErrorHandler(error),
    addHolidayIsLoading: isPending,
    addHolidayPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useEditHoliday = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.updateHoliday(payload?.holiday_id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Holiday updated successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    editHolidayData: data,
    editHolidayError: ErrorHandler(error),
    editHolidayIsLoading: isPending,
    editHolidayPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useDeleteHoliday = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (id) =>
      httpService.deleteData(routes.deleteHoliday(id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Holiday deleted successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    deleteHolidayData: data,
    deleteHolidayError: ErrorHandler(error),
    deleteHolidayIsLoading: isPending,
    deleteHolidayPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useBulkImportHolidays = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.postData(payload, routes.bulkImportHolidays()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Holidays imported successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    bulkImportHolidaysData: data,
    bulkImportHolidaysError: ErrorHandler(error),
    bulkImportHolidaysIsLoading: isPending,
    bulkImportHolidaysPayload: (requestPayload) => mutate(requestPayload),
  };
};

// Location Settings Hooks
export const useGetLocationSettings = ({ enabled = true } = {}) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
    queryKey: ["LocationSettings"],
    queryFn: () => httpService.getData(routes.getLocationSettings()),
    enabled,
    retry: 2
  });

  return {
    locationSettingsIsFetching: isFetching,
    locationSettingsIsFetched: isFetched,
    locationSettingsIsLoading: isLoading,
    locationSettingsError: ErrorHandler(error),
    locationSettingsData: data?.data || null,
    refetchLocationSettings: refetch
  };
};

export const useUpdateLocationSettings = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.updateLocationSettings()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Location settings updated successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    updateLocationSettingsData: data,
    updateLocationSettingsError: ErrorHandler(error),
    updateLocationSettingsIsLoading: isPending,
    updateLocationSettingsPayload: (requestPayload) => mutate(requestPayload),
  };
};

// Break Settings Hooks
export const useGetBreakSettings = ({ enabled = true } = {}) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
    queryKey: ["BreakSettings"],
    queryFn: () => httpService.getData(routes.getBreakSettings()),
    enabled,
    retry: 2
  });

  return {
    breakSettingsIsFetching: isFetching,
    breakSettingsIsFetched: isFetched,
    breakSettingsIsLoading: isLoading,
    breakSettingsError: ErrorHandler(error),
    breakSettingsData: data?.data || null,
    refetchBreakSettings: refetch
  };
};

export const useUpdateBreakSettings = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.updateBreakSettings()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Break settings updated successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    updateBreakSettingsData: data,
    updateBreakSettingsError: ErrorHandler(error),
    updateBreakSettingsIsLoading: isPending,
    updateBreakSettingsPayload: (requestPayload) => mutate(requestPayload),
  };
};

export const useGetEmployeeBreakSettings = ({ employeeId, enabled = true } = {}) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
    queryKey: ["EmployeeBreakSettings", employeeId],
    queryFn: () => httpService.getData(routes.getEmployeeBreakSettings(employeeId)),
    enabled: enabled && !!employeeId,
    retry: 2
  });

  return {
    employeeBreakSettingsIsFetching: isFetching,
    employeeBreakSettingsIsFetched: isFetched,
    employeeBreakSettingsIsLoading: isLoading,
    employeeBreakSettingsError: ErrorHandler(error),
    employeeBreakSettingsData: data?.data || null,
    refetchEmployeeBreakSettings: refetch
  };
};

export const useUpdateEmployeeBreakSettings = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) =>
      httpService.putData(payload, routes.updateEmployeeBreakSettings(payload?.employee_id)),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Employee break settings updated successfully");
      handleSuccess(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    updateEmployeeBreakSettingsData: data,
    updateEmployeeBreakSettingsError: ErrorHandler(error),
    updateEmployeeBreakSettingsIsLoading: isPending,
    updateEmployeeBreakSettingsPayload: (requestPayload) => mutate(requestPayload),
  };
};